import { useEffect, useRef, useState } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import useModalSelecaoTalhoes from "../../../hooks/useModalSelecaoTalhoes";
import { CurrentViewTypeEnum } from "components/maps/base-map/typings";
import { MarkersContainer } from "./styles";

type Props = {
  talhoes: any[];
  unidadeGeoJSON?: any;
  currentType: CurrentViewTypeEnum;
};

export default function MapTalhoes({
  talhoes,
  unidadeGeoJSON,
  currentType,
}: Props) {
  const mapRef = useRef<google.maps.Map | null>(null);
  const baseLayerRef = useRef<google.maps.Data | null>(null);
  const activeLayerRef = useRef<google.maps.Data | null>(null);
  const [showMarkers, setShowMarkers] = useState(true);
  const { talhaoLogico, listTalhoesLogicos } = useModalSelecaoTalhoes();

  const renderLayers = () => {
    if (!baseLayerRef.current || !activeLayerRef.current || !unidadeGeoJSON)
      return;

    const baseLayer = baseLayerRef.current;
    const activeLayer = activeLayerRef.current;

    baseLayer.forEach(f => baseLayer.remove(f));
    activeLayer.forEach(f => activeLayer.remove(f));

    baseLayer.addGeoJson(unidadeGeoJSON);

    baseLayer.setStyle({
      strokeColor: "#FFFFFF",
      strokeWeight: 1.5,
      strokeOpacity: 1,
      fillOpacity: 0,
      clickable: false,
    });

    const codessAtivos = new Set(talhoes.map(t => String(t.codigo)));

    const filtered = {
      type: "FeatureCollection",
      features: unidadeGeoJSON.features.filter((f: any) =>
        codessAtivos.has(String(f.id))
      ),
    };

    activeLayer.addGeoJson(filtered);

    activeLayer.setStyle(feature => {
      const isSelected =
        talhaoLogico?.talhaoId === feature.getId();
        const newTalhoes =  talhoes?.map(t => {
          return {
            ...t,
            checked: listTalhoesLogicos?.includes(String(t.talhaoId))
          }
        });
      
        const isSelectedMap =  newTalhoes?.find(t => t.codigo === feature.getId())?.checked;

      return {
        strokeColor: isSelected ? "#00FFFF" : "#FFFFFF",
        strokeWeight: isSelected ? 3 : 2,
        strokeOpacity: 1,
        fillColor: isSelectedMap ? "#009157" : "transparent",
        fillOpacity: 1,
      };
    });
  };

  const handleMapLoad = (map: google.maps.Map) => {
    mapRef.current = map;

    baseLayerRef.current = new google.maps.Data({ map });
    activeLayerRef.current = new google.maps.Data({ map });

    renderLayers();

    if (unidadeGeoJSON?.Properties) {
      const bounds = new google.maps.LatLngBounds(
        {
          lat: unidadeGeoJSON.Properties.latitudeMinima,
          lng: unidadeGeoJSON.Properties.longitudeMinima,
        },
        {
          lat: unidadeGeoJSON.Properties.latitudeMaxima,
          lng: unidadeGeoJSON.Properties.longitudeMaxima,
        }
      );

       map.addListener("zoom_changed", () => {
    setShowMarkers(false);
  });

  map.addListener("idle", () => {
    setShowMarkers(true);
  });

      map.fitBounds(bounds);
    }
  };

  useEffect(() => {
    renderLayers();
  }, [talhoes, unidadeGeoJSON, talhaoLogico, currentType]);

  useEffect(() => {
    if (!mapRef.current || !activeLayerRef.current || !talhaoLogico)
      return;

    const map = mapRef.current;
    const layer = activeLayerRef.current;

    layer.forEach(feature => {
      const codigo = feature.getProperty("codigo");

      if (String(codigo) !== String(talhaoLogico.codigo)) return;


      const bounds = new google.maps.LatLngBounds();
      const geometry = feature.getGeometry();

      if (!geometry) return;

      geometry.forEachLatLng((latLng: google.maps.LatLng) => {
        bounds.extend(latLng);
      });

      map.fitBounds(bounds);
    });
  }, [talhaoLogico]);


  return (
    <GoogleMap
      onLoad={handleMapLoad}
      mapContainerStyle={{ width: "100%", height: "100%" }}
      options={{
        mapTypeId: "hybrid",
        disableDefaultUI: true,
        zoomControl: true,
      }}
    >
      <MarkersContainer>
        { showMarkers &&
          unidadeGeoJSON?.features?.map((item: any) => (
            <Marker
              visible={
                currentType !== CurrentViewTypeEnum.transparent
              }
              
              label={{
                text: item.properties?.codigo,
                color:
                  currentType === CurrentViewTypeEnum.box ? "#000" : "#fff",
                fontWeight:
                  currentType === CurrentViewTypeEnum.box
                    ? "regular"
                    : "bold",
              }}
              icon={{
                url: "/marker.png",
                size:
                  currentType !== CurrentViewTypeEnum.box
                    ? new google.maps.Size(0, 0)
                    : undefined,
              }}
              position={{
                lat: item.properties?.pontoCentralLat,
                lng: item.properties?.pontoCentralLong,
              }}
            />
          ))
        }
      </MarkersContainer>
    </GoogleMap>
  );
}
